module.exports = {"130983001":"骅东街道","130983002":"骅中街道","130983003":"骅西街道","130983100":"黄骅镇","130983101":"南排河镇","130983102":"吕桥镇","130983103":"旧城镇","130983200":"羊二庄回族乡","130983202":"常郭乡","130983203":"滕庄子乡","130983204":"官庄乡","130983205":"齐家务乡","130983207":"羊三木回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130983.json
// module id = 230
// module chunks = 0